module.exports = __webpack_public_path__ + "img/25_11.2a8374d5.png";